import { render, staticRenderFns } from "./TrackerDataTableItemEdit.html?vue&type=template&id=b2a0c9f4&scoped=true&external"
import script from "./TrackerDataTableItemEdit.js?vue&type=script&lang=js&external"
export * from "./TrackerDataTableItemEdit.js?vue&type=script&lang=js&external"
import style0 from "./TrackerDataTableItemEdit.css?vue&type=style&index=0&id=b2a0c9f4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a0c9f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VSpacer})
